import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { hotTags } from "@/mocks/posts";

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  function handleSearch(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/hot?q=${encodeURIComponent(q)}` : "/hot");
  }

  return (
    <section className="relative w-full min-h-[560px] md:min-h-[660px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20layered%20paper%20collage%20of%20a%20warm%20night%20city%20skyline%20with%20glowing%20amber%20windows%20and%20floating%20chat%20bubbles%2C%20stylized%20editorial%20illustration%2C%20rich%20crimson%20and%20teal%20accents%20on%20deep%20espresso%20background%2C%20textured%20grain%2C%20artistic%20and%20modern%2C%20high%20contrast&width=1800&height=1100&seq=hero-gossip-night-01&orientation=landscape"
        alt="夜晚城市与信息气泡的抽象拼贴插画"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/55 to-foreground-950/80"></div>

      <div className="relative w-full max-w-content mx-auto px-4 md:px-8 pt-28 pb-16 md:pt-32 md:pb-20">
        <div className="max-w-3xl animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-background-100 text-xs md:text-sm">
            <i className="ri-fire-fill text-primary-300"></i>
            热帖专区 · 高赞神回复 · 加精置顶
          </span>

          <h1 className="mt-6 font-heading font-black text-background-50 text-3xl md:text-5xl lg:text-6xl leading-[1.15] tracking-tight">
            黑料网社
            <span className="block mt-2 text-2xl md:text-4xl lg:text-[2.6rem] text-primary-200">
              今日热帖与高赞神回复，一站看够
            </span>
          </h1>

          <p className="mt-5 md:mt-6 text-sm md:text-lg text-background-100/90 leading-relaxed max-w-2xl">
            热评区老哥金句频出，围观群众不迷路。想快速 get 今天最火的那件事，
            直接刷热帖榜就完事。
          </p>

          <form onSubmit={handleSearch} className="mt-7 md:mt-8 max-w-xl">
            <div className="flex flex-col sm:flex-row gap-2.5 p-2 rounded-lg bg-background-50/12 border border-background-50/25 backdrop-blur">
              <label className="flex-1 flex items-center gap-2 px-3">
                <i className="ri-search-line text-background-200"></i>
                <span className="sr-only">搜索热帖</span>
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索热帖、神回复或关键词…"
                  className="w-full h-10 bg-transparent text-sm text-background-50 placeholder:text-background-300 outline-none"
                />
              </label>
              <button
                type="submit"
                className="h-10 px-6 rounded-md text-sm font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
              >
                去围观
              </button>
            </div>
          </form>

          <div className="mt-6 md:mt-7 flex flex-wrap items-center gap-2">
            <span className="text-xs text-background-300 mr-1">热门标签</span>
            {hotTags.slice(0, 6).map((tag) => (
              <button
                key={tag}
                type="button"
                onClick={() => navigate(`/hot?q=${encodeURIComponent(tag)}`)}
                className="px-3 py-1.5 rounded-full text-xs text-background-100 bg-background-50/10 border border-background-50/20 hover:bg-background-50/20 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                {tag}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}